import React from "react";
import classNames from "classnames/bind";
import { Info as InfoIcon } from "@phosphor-icons/react";
import { Tooltip } from "../Tooltip";
import styles from "./Info.module.scss";
import colours from "../constants/colours";

import type { InfoProps } from "./types";

const cx = classNames.bind(styles);

/**
 * An info icon wrapped with a Tooltip
 *
 * @deprecated use the Icon and Tooltip components together manually
 */
const Info = (props: InfoProps) => {
  return (
    <Tooltip {...props}>
      <div className={cx("container")}>
        <InfoIcon
          weight="bold"
          size={16}
          color={colours.colours.navy[300]}
          data-testid="info-icon"
        />
      </div>
    </Tooltip>
  );
};

export default Info;
